import { PetsSaveError } from '@spike/pets-action';
import { RootState } from 'store';

export const selectVaccineRecordSaveError = (state: RootState): PetsSaveError | undefined => state.pets.saveError;
